import React, { useEffect, useState, useContext } from 'react';
import { Link } from "react-router-dom";
import { MenuContext } from '../../context/MenuContext';
import './index.css';


function Header() {
  const desktopWidth = 1000;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > desktopWidth);
  const {menu, toggleMenu} = useContext(MenuContext);

  useEffect(() => {
    if (menu) {
      document.body.classList.add('menu-on');
    } else {
      document.body.classList.remove('menu-on');
    }
  }, [menu]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > desktopWidth);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header>
      <div className="wrapper">
        <h1><a href="/">Banco Provincia</a></h1>  
        <div className="navigation">
          {/* isDesktop
          ?
            <ul className='external-nav'>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer'>Personas</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer'>Empresas</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer'>Emprendedores</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer'>Provincia Compras</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer'>Turnos web</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer' className='btn'>BIP Personas</a></li>
              <li><a href="https://www.google.com" target='_blank' rel='noreferrer' className='btn'>BIP Empresas</a></li>
            </ul>
          :
          <ul className='social'>
            <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='fb'>Facebook</a></li>
            <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='in'>Instagram</a></li>
            <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='yt'>YouTube</a></li>
          </ul>
         */}
        <button onClick={toggleMenu} className='menutoggle'><span>toggle menu</span></button>
        </div>
      </div>
      {menu && <>
        <>
          <div className="over"></div>
          <menu>
            <ul>
              <li><Link onClick={toggleMenu} to='/'>Inicio</Link></li>
              <li><Link onClick={toggleMenu} to='/que-es-incluir'>Qué es incluir</Link></li>
              <li><Link onClick={toggleMenu} to='/programa-en-numeros'>El programa en números</Link></li>
              <li><Link onClick={toggleMenu} to='/movimiento'>Incluir en movimiento</Link></li>
              <li><Link onClick={toggleMenu} to='/rico-en-data'>Rico en Data</Link></li>
              <li>Segmentos</li>
              <li className='sub'><Link onClick={toggleMenu} to='/adultos-mayores'>Tengo más de 60 años</Link></li>
              <li className='sub'><Link onClick={toggleMenu} to='/adolescentes'>Tengo entre 13 y 17 años</Link></li>
              <li className='sub'><Link onClick={toggleMenu} to='/mujer-emprendedora'>Soy mujer emprendedora</Link></li>
              <li className='sub'><Link onClick={toggleMenu} to='/micro-emprendimientos'>Tengo un micro emprendimiento</Link></li>
              <li className='sub'><Link onClick={toggleMenu} to='/funcionario-municipal'>Soy funcionaria/o municipal</Link></li>
              <li><Link onClick={toggleMenu} to='/encuentros'>Calendario de Encuentros</Link></li>
              <li><Link onClick={toggleMenu} to='/glosario'>Glosario</Link></li>
              <li><a href='mailto:incluir@bpba.com.ar'>Contacto</a></li>
            </ul>
            <hr />
            <button onClick={toggleMenu}>
              <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 36 36" width="23px" height="23px"><path d="M26,11.07,11.19,25.92a.7.7,0,0,1-1-1L25.05,10.08a.7.7,0,1,1,1,1Z"></path><path d="M25.05,25.92,10.2,11.07a.7.7,0,0,1,1-1L26,24.93a.7.7,0,1,1-1,1Z"></path></svg>
              <span>Cerrar</span>
            </button>
          </menu>
        </>
      </>}
    </header>
  );
}

export default Header;